// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDHmsBbkHdud7Pxv7FajY7NDizfFsM98cU",
  authDomain: "h2auth-website.firebaseapp.com",
  projectId: "h2auth-website",
  storageBucket: "h2auth-website.appspot.com",
  messagingSenderId: "489687974924",
  appId: "1:489687974924:web:db12fcba043ec37ee41a29"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
